
import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import { WellStringStatus } from 'app/modules/cdft/model/cdft.model';

@Injectable({ providedIn: 'root' })
export class WellStringStatusState extends State<WellStringStatus> implements WellStringStatus  {
    id: string;
    wellStringId: string;
    platformShortName: string;
    platformLongName: string;
    fieldShortName: string;
    fieldLongName: string;
    wellShortName: string;
    wellLongName: string;
    stringShortName: string;
    stringLongName: string;
    stringIndicatorShortName: string;
    wellStringType: string;
    stringIndicator: string;
    wellFlowCategory: string;
    prodStatus: string;
    lastUpdatedBy: string;
    lastUpdatedDate: string;

    constructor() { 
        super();
    }

    nullToString() {
        for (const key in this) {
            const data: any = this[key] === null ? '' : this[key]; 
            this[key] = data;
        }
    }

    toHeaderForm() {
        return {
            platformName: this.platformLongName ?? null,
            wellName: this.stringShortName ?? null,
            wellType: this.wellStringType ?? null,
        }
    }

    toHeaderFormApi() {
        return {
            wellStringId: this.wellStringId ?? null,
            wellStatus: this.prodStatus ?? null,
            wellFlowCategory: this.wellFlowCategory ?? null
        }
    }
}
  